import React, { useState, useCallback, useEffect } from "react";
import {
  CardText
} from "material-ui/Card";
import { List, ListItem } from "material-ui/List";
import Avatar from "material-ui/Avatar";
import md5 from "js-md5";
import moment from "moment";
import FlatButton from "material-ui/FlatButton";
import NextIcon from "material-ui/svg-icons/navigation/chevron-right";
import PrevIcon from "material-ui/svg-icons/navigation/chevron-left";
import LinearProgress from "material-ui/LinearProgress";
import { makeTitle } from "../reducer";
import useResponses from '../hooks/useResponses';
import Checkbox from 'material-ui/Checkbox';
import { useSelector } from 'react-redux';
import {multiResponseAnswerExport, multiResponseOptionExport} from '../Reports/MultiExports'

const UserResponseList = ({ onClick, limit=12, forReports = false, handleCreateExport = null, section = null, viewedResponse, monitoringQuestions, assessmentQuestions, controlRulesQuestions, options, categories, calculateResults = null, translation }) => {
  const { responses, fetching, min, max, hasMore, onNext, onPrevious } = useResponses(limit);

  const [selectedResponses, setSelectedResponses] = useState([viewedResponse]);
  const handleCheck = (checked, response) => {
    var updatedList = [...selectedResponses];
    if (checked) {
      updatedList = [...selectedResponses, response];
    } else {
      updatedList.splice(selectedResponses.map(r => r.metadata.id).indexOf(response.metadata.id), 1);
    }
    setSelectedResponses(updatedList);
  };

  const generateExports = (exportType) => {
    var secQuestions;
    if(section === "monitoring"){
      secQuestions = monitoringQuestions;
    } else if(section === "assessment"){
      secQuestions = assessmentQuestions;
    } else if(section === "controlRules"){
      secQuestions = controlRulesQuestions;
    }

    if(exportType === "answers"){
      multiResponseAnswerExport(selectedResponses, section, secQuestions, categories, translation)
    } else { // options for a section
      multiResponseOptionExport(selectedResponses, section, options, categories, calculateResults)
    }
  }

  useEffect(() => {
    if(forReports){handleCreateExport(generateExports);}
  }, [selectedResponses])

  return (
    <div>
      <CardText style={{ textAlign: "center" }}>
        <FlatButton
          disabled={min === 1 || fetching}
          icon={<PrevIcon />}
          labelPosition="after"
          onClick={onPrevious}
          label="Newer"
        />
        &nbsp; Showing {min} - {max} &nbsp;
        <FlatButton
          labelPosition="before"
          onClick={onNext}
          disabled={!hasMore || fetching}
          label="Older"
          icon={<NextIcon />}
        />
      </CardText>
      {fetching ? <LinearProgress mode="indeterminate" /> : null}
      <List>
        {responses.map(response => {
          let numSectionsComplete = [
            "monitoring",
            "assessment",
            "controlRules"
          ].reduce((count, section) => {
            if (response.metadata.completedSections[section]) {
              count++;
            }
            return count;
          }, 0);
          return (
            <ListItem
              onClick={() => onClick(response)}
              leftCheckbox={forReports ? <Checkbox onCheck={(e) => handleCheck(e.target.checked, response)} checked={selectedResponses.map(r => r.metadata.id).includes(response.metadata.id)} disabled={!response.completedSections[section]}/> : null}
              leftAvatar={ forReports ? null :
                  <Avatar
                    src={`https://www.gravatar.com/avatar/${md5(
                      response.email
                    )}?d=mm`}
                  />
                }
              key={response.metadata.id}
              primaryText={response.name}
              secondaryText={
                <span>
                  {`${makeTitle(response)}`}
                  <em>{response.context ? ` - ${response.context}` : ""}</em>
                </span>
              }
              rightIcon={
                <span
                  style={{
                    width: "auto",
                    color: "grey",
                    fontWeight: "lighter"
                  }}
                >
                  {moment(response.metadata.createdAt).fromNow()}
                </span>
              }
            />
          );
        })}
      </List>
    </div>
  );
};

export default UserResponseList;
